/**
 * Pre-compiled en messages for LoadingSpinner
 * Generated by @internationalized/string-compiler
 * DO NOT EDIT MANUALLY
 */

export default { default: `Loading data` };
